import { useMemo } from 'react';
const computeIsConnected = ({ chainId, accounts, isConnecting, }) => {
    return Boolean(chainId && accounts?.length && !isConnecting);
};
const ACCOUNTS_EQUALITY_CHECKER = (oldAccounts, newAccounts) => {
    if (oldAccounts === undefined && newAccounts === undefined)
        return true;
    if (oldAccounts === undefined && newAccounts !== undefined)
        return false;
    if (oldAccounts !== undefined && newAccounts === undefined)
        return false;
    if (oldAccounts?.length !== newAccounts?.length)
        return false;
    return !!oldAccounts?.every((oldAccount, i) => oldAccount === newAccounts?.[i]);
};
export const createCoreHooks = (wallet) => {
    const { getStore } = wallet;
    const useStore = getStore();
    const useIsConnecting = () => useStore((s) => s.isConnecting);
    const useChainId = () => useStore((s) => s.chainId);
    const useAccounts = () => useStore((s) => s.accounts, ACCOUNTS_EQUALITY_CHECKER);
    const useIsConnected = () => {
        const isConnecting = useIsConnecting();
        const chainId = useChainId();
        const accounts = useAccounts();
        return useMemo(() => computeIsConnected({
            isConnecting,
            chainId,
            accounts,
        }), [isConnecting, chainId, accounts]);
    };
    const useAccount = () => useAccounts()?.[0];
    return {
        useIsConnecting,
        useChainId,
        useAccounts,
        useIsConnected,
        useAccount,
    };
};
